<template>
  <div>
    <v-container>
      <span class="text-center body-2">Membership Fee</span>
      <br/>
      <v-row>
        <v-col cols="12" md="4" sm="6">
          <deductions
            :class-padding="classPadding"
            :title="'Deduction'"
            :label="'Membership Fee Deduction Code'"
            v-model="selectedDed"
            :code-value="false"
          ></deductions>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field
            label="Total Amount"
            v-model="model.memberTotAmount"
            :class="classPadding"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field
            label="Amortization"
            v-model="model.memberAmort"
            :class="classPadding"
            type="number"
          ></v-text-field>
        </v-col>

         <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field
            label="Period No."
            v-model="model.memberPeriod"
            :class="classPadding"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <span class="text-center body-2">Capital Share</span>
      <v-row>
        <v-col cols="12" md="4" sm="6">
          <deductions
            :class-padding="classPadding"
            :title="'Deduction'"
            :label="'Capital Share Deduction Code'"
            v-model="selectedCapital"
            :code-value="false"
          ></deductions>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field
            label="Total Amount"
            v-model="model.capitalTotAmount"
            :class="classPadding"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field
            label="Amortization"
            v-model="model.capitalAmort"
            :class="classPadding"
            type="number"
          ></v-text-field>
        </v-col>

         <v-col cols="12" md="3" sm="6" :class="classPadding">
          <v-text-field
            label="Period No."
            v-model="model.capitalPeriod"
            :class="classPadding"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
const Deductions = () => import("../../general/earnings-deductions/LookupDeduction");
import isEmpty from "lodash/isEmpty"
export default {
  props: [
    "value"
  ],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {},
    selectedDed: {},
    selectedCapital:{}
  }),
  components: {
    Deductions
  },
  watch: {
    selectedDed(val) {
      this.model.memberDedCode = val.code;
    },
    selectedCapital(val) {
      this.model.capitalDedCode = val.code;
    },
    model: {
      handler(val){
        this.$emit("input", val)
      },
      deep: true
    }
  },
  mounted() {
    if(!isEmpty(this.value)){

      this.model = Object.assign({}, this.value);

      this.selectedDed = {
        code: this.model.memberDedCode,
        desc: this.model.memberDedDesc,
      }

       this.selectedCapital = {
        code: this.model.capitalDedCode,
        desc: this.model.capitalDedDesc,
      }
    }
  }
}
</script>